import { useState } from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import { Input } from '../components/ui/Input';
import { Button } from '../components/ui/Button';
import logo from "../assets/logo.png";

export const Login = () => {
  const { user, login } = useAuth();
  const [credentials, setCredentials] = useState({ email: '', password: '' });
  const [error, setError] = useState('');
  const [isLoading, setIsLoading] = useState(false);

  if (user) {
    return <Navigate to="/dashboard" replace />;
  }

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setIsLoading(true);

    try {
      await login(credentials.email, credentials.password);
    } catch (err) {
      setError(err.message);
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <div className="min-h-screen bg-white from-slate-900 via-blue-900 to-slate-900 flex items-center justify-center p-4">
      <div className="w-full max-w-md">
        <div className="bg-white rounded-2xl shadow-2xl p-8">
          <div className="flex flex-col items-center justify-center bg-gradient-to-r from-[#472f92] to-[#6a4bc5] text-center shadow-xl rounded-2xl p-6 sm:p-8 text-white mb-6 sm:mb-8 transition-all">
            <img
              src={logo}
              alt="Fayda Logo"
              className="h-12 sm:h-16 object-contain"
            />
            <h1 className="text-3xl font-bold text-white">KYC Portal</h1>
            <p className="text-white/90 mt-2">Verification & Compliance System</p>
          </div>

          <form onSubmit={handleSubmit} className="space-y-5">
            <Input
              label="Username"
              type="text"
              value={credentials.email}
              onChange={(e) => setCredentials({ ...credentials, email: e.target.value })}
              placeholder="Enter your email or username"
              required
              autoComplete="username"
              className='w-full px-4 py-3 sm:py-4 border-2 border-slate-200 rounded-lg focus:border-blue-500 focus:ring-2 focus:ring-blue-200 outline-none text-base sm:text-lg'
            />

            <Input
              label="Password"
              type="password"
              value={credentials.password}
              onChange={(e) => setCredentials({ ...credentials, password: e.target.value })}
              placeholder="Enter your password"
              required
              autoComplete="current-password"
              className='w-full px-4 py-3 sm:py-4 border-2 border-slate-200 rounded-lg focus:border-blue-500 focus:ring-2 focus:ring-blue-200 outline-none text-base sm:text-lg'
            />

            {error && (
              <div className="bg-red-50 border border-red-200 text-red-700 px-4 py-3 rounded-lg text-sm">
                {error}
              </div>
            )}

            <Button 
              type="submit" 
              className="w-full bg-gradient-to-r from-[#472f92] to-[#e4aa24] text-white font-semibold py-3 sm:py-4 rounded-lg hover:opacity-90 transition-opacity" 
              isLoading={isLoading}
            >
              Sign In
            </Button>
          </form>

      
        </div>

        <p className="text-center text-white text-sm mt-6 opacity-75">
          © 2026 KYC Portal. All rights reserved.
        </p>
      </div>
    </div>
  );
};